import { Component, Input } from '@angular/core';
import { AsicStatusPipe } from '@shared/pipes/asicStatusPipe';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AsicStatus } from '@models/documents/asic-status.enum';

@Component({
  selector: 'app-ag-asic-document-status',
  standalone: true,
  imports: [
    AsicStatusPipe,
  ],
  templateUrl: './ag-asic-document-status.component.html',
  styleUrl: './ag-asic-document-status.component.scss'
})
export class AgAsicDocumentStatusComponent implements ICellRendererAngularComp {
  readonly AsicStatus = AsicStatus;

  @Input() status: AsicStatus | undefined = AsicStatus.NotLodged;

  agInit(params: ICellRendererParams): void {
    this.status = params.value as number;
  }

  refresh(params: ICellRendererParams): boolean {
    this.status = params.value as number;
    return true;
  }
}
